import { store } from '@redux/store';
import { selfGuidedActions, SelfGuidedTourModal } from 'features/selfGuidedTour';
import { filter, fromEvent, map } from 'rxjs';

function openSelfGuidedTourModal() {
  const jsonContainer = document.querySelector('[data-self-guided-tour-data]');

  const specData = jsonContainer ? JSON.parse(jsonContainer.innerHTML) : {};
  const { specId } = specData;

  store.dispatch(selfGuidedActions.createModal({ specId }));
}

const onClickSelfGuidedButton$ = fromEvent(document.body, 'click').pipe(
  map(event => event.target.closest('[data-self-guided-tour-trigger]')),
  filter(Boolean)
);

onClickSelfGuidedButton$.subscribe(openSelfGuidedTourModal);
(() => new SelfGuidedTourModal())();